import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAccountStore } from '@nimbitlabs/features';
import { CreateAccount } from './CreateAccount';

interface CreateAccountPageProps {
  successPath?: string;
}

export function CreateAccountPage({ successPath = '/dashboard' }: CreateAccountPageProps) {
  try {
    const { user, switchAccount, isLoading } = useAuth();
    const navigate = useNavigate();
    const { accounts: accountsData, fetchAccounts, createAccount } = useAccountStore();

    useEffect(() => {
      if (user) {
        fetchAccounts({ silent: true });
      }
    }, [user, fetchAccounts]);
    
    // Redirect to login if no user
    useEffect(() => {
      if (!isLoading && !user) {
        navigate('/login');
      }
    }, [user, isLoading, navigate]);
    
    if (isLoading) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">Loading...</div>
        </div>
      );
    }
    
    if (!user) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">Redirecting to login...</div>
        </div>
      );
    }
    
    return (
      <CreateAccount
        user={user}
        onLoadAccounts={async () => {
          return accountsData || [];
        }}
        onCreateAccount={async (data) => {
          const result = await createAccount({
            name: data.name,
            companyName: data.companyName,
            email: data.email,
            phone: data.phone || undefined,
          });
          return result;
        }}
        onAccountCreated={async (accountId) => {
          await switchAccount(accountId);
        }}
        successPath={successPath}
      />
    );
  } catch (error) {
    console.error('[CreateAccountPage] Error:', error);
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center text-red-500">
          Error loading page: {error instanceof Error ? error.message : 'Unknown error'}
        </div>
      </div>
    );
  }
}
